import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-email-remove.component',
  templateUrl: './icon-email-remove.component.html',
  styleUrl: './icon-email-remove.component.scss',
  standalone: false,
})
export class IconEmailRemoveComponent {
  @Input() tooltip?: string;
}
